import { useEffect, useState } from "react";
import FavoriteButton from "src/pages/DashboardPage/acadia/components/FavoriteButton";
import { documentRegistryFilters } from "src/api/config";
import DialogComponent from "src/components/DialogComponent";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import InputFilterSet from "src/components/InputFilterSet";
import TGButton from "src/components/ui/TGButton";
import SaveIcon from "src/components/ui-icons/SaveIcon";
import { useAppSelector } from "src/hooks/redux";
import { SelectedCurrentUser } from "src/modules/users/types";
import { selectCurrentUser } from "src/modules/users/selector";
import { addItemRequest, deleteItemRequest, getItemsRequest } from "src/modules/spItems/api";
import Loading from "src/components/Loading";

export const FavoriteButtonFilters = ({ filters, displayFilters, reRenderFilterSettings, setReRenderFilterSettings, filtersParams }: { filters: string, displayFilters: string, reRenderFilterSettings: boolean, setReRenderFilterSettings: any, filtersParams: any }) => {

  const [isSaved, setIsSaved] = useState(false);
  const [isFavorite, setIsFavorite] = useState<{ state: boolean; id: number | null }>({ state: false, id: null });
  const currentUser: SelectedCurrentUser = useAppSelector(selectCurrentUser);
  const [loading, setLoading] = useState(false);
  const [filterTitle, setFilterTitle] = useState("");

  useEffect(() => {
    setLoading(true);
    getItemsRequest({ listName: documentRegistryFilters, filters: { Creator: currentUser.email } }).then(results => {
      const favoriteFilters = [...results.items.filter((item: any) => item.DocumentsFilters === filters)];
      if (favoriteFilters.length > 0) {
        setIsFavorite({
          state: true,
          id: favoriteFilters[0]['ID']
        });
      } else {
        setIsFavorite({ state: false, id: null });
      }
      setLoading(false);
    });
  }, [reRenderFilterSettings, filters]);

  const toggleFavorite = () => {
    setLoading(true);
    if (!isFavorite.id) {
      addItemRequest({
        listName: documentRegistryFilters,
        body: {
          DocumentsFilters: filters,
          DisplayFilters: displayFilters,
          Filters: filtersParams,
          Title: filterTitle,
          Creator: currentUser.email
        },
      }).then(id => {
        closeDialog();
        setFilterTitle("");
        setReRenderFilterSettings(!reRenderFilterSettings);
      });
    } else {
      deleteItemRequest({
        listName: documentRegistryFilters,
        ID: isFavorite.id,
      }).then(() => {
        closeDialog();
        setFilterTitle("");
        setReRenderFilterSettings(!reRenderFilterSettings);
      })
    }
  }

  function openDialog() {
    setIsSaved(true);
  }

  function closeDialog() {
    setIsSaved(false);
    setFilterTitle("");
  }

  return (
    <>
      {filters &&
        <>
          {loading &&
            <FlexCol className="flex w-6 h-6">
              <Loading />
            </FlexCol> ||
            <FavoriteButton isFavorite={isFavorite} onToggle={isFavorite.state && isFavorite.id ? toggleFavorite : openDialog} />
          }
          <DialogComponent open={isSaved} toggleDialog={closeDialog}>
            <FlexCol className="w-[600px] shrink">
              <FlexRow className="mb-9">
                <h3 className="text-black">Назовите набор фильтров</h3>
              </FlexRow>
              <FlexRow className="mb-9">
                <InputFilterSet initial={filterTitle} onChange={setFilterTitle} />
              </FlexRow>
              <FlexRow className="justify-between px-10 pt-10 -mx-10 border-t">
                <FlexCol>
                  <TGButton onClick={closeDialog}>Отмена</TGButton>
                </FlexCol>
                <FlexCol>
                  <TGButton color="bluedark" icon={<SaveIcon />} onClick={toggleFavorite}>
                    Сохранить
                  </TGButton>
                </FlexCol>
              </FlexRow>
            </FlexCol>
          </DialogComponent>
        </>
      }
    </>
  );
};
